var _circle, _g, _path, _g2, _path2, _g3, _g4, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintaince(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 226,
    viewBox: "0 0 227 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 113,
    r: 113,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32346_435055)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_32346_435055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.738 45.1426H113.577C111.649 45.1426 109.888 46.492 109.128 48.5844L67.8799 161.678C78.0668 164.65 90.8497 167.364 105.713 168.259C130.246 169.744 150.59 165.681 164.42 161.678C150.681 123.985 136.926 86.2773 123.187 48.5844C122.428 46.5072 120.682 45.1426 118.738 45.1426Z",
    fill: "url(#paint0_linear_32346_435055)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32346_435055",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 45,
    width: 98,
    height: 124
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.738 45.1426H113.577C111.649 45.1426 109.888 46.492 109.128 48.5844L67.8799 161.678C78.0668 164.65 90.8497 167.364 105.713 168.259C130.246 169.744 150.59 165.681 164.42 161.678C150.681 123.985 136.926 86.2773 123.187 48.5844C122.428 46.5072 120.682 45.1426 118.738 45.1426Z",
    fill: "url(#paint1_linear_32346_435055)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32346_435055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.486 73.4355H71.2656V96.8003H159.486V73.4355Z",
    fill: "#F7FAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.486 119.119H71.2656V142.484H159.486V119.119Z",
    fill: "#F7FAF9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.006 119.755C122.685 126.578 120.711 133.189 118.297 139.708C116.111 145.622 113.561 151.641 109.538 156.569C107.959 158.509 113.054 155.688 99.7606 166.015C86.4675 176.341 164.435 161.663 164.435 161.663L123.186 48.5844C122.427 46.492 120.666 45.1426 118.738 45.1426H118.146C125.767 69.1744 128.818 94.8287 124.006 119.755Z",
    fill: "url(#paint2_linear_32346_435055)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_32346_435055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.24 170.244C135.529 177.477 96.7852 177.477 59.074 170.244C56.6753 169.789 55.1268 167.545 55.6126 165.271C55.7796 164.452 55.9466 163.634 56.1288 162.815C56.5994 160.541 58.8463 159.1 61.1387 159.54C97.4836 166.514 134.83 166.514 171.191 159.54C173.483 159.1 175.73 160.556 176.2 162.815C176.367 163.634 176.534 164.452 176.717 165.271C177.187 167.545 175.639 169.774 173.255 170.244H173.24Z",
    fill: "url(#paint3_linear_32346_435055)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_32346_435055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.797 105.493L85.7574 76.4527C85.0036 75.6989 83.7815 75.6989 83.0278 76.4527L53.9877 105.493C53.2339 106.247 53.2339 107.469 53.9877 108.222L83.0278 137.262C83.7815 138.016 85.0036 138.016 85.7574 137.262L114.797 108.222C115.551 107.469 115.551 106.247 114.797 105.493Z",
    fill: "url(#paint4_linear_32346_435055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3926 133.709C83.7532 133.709 83.1139 133.468 82.6314 132.979L58.2699 108.624C57.7994 108.153 57.54 107.526 57.54 106.863C57.54 106.199 57.7994 105.572 58.2699 105.102L82.6253 80.74C83.5964 79.7689 85.1767 79.7689 86.1478 80.74L110.509 105.095C110.98 105.566 111.239 106.193 111.239 106.857C111.239 107.52 110.98 108.147 110.509 108.618L86.1478 132.979C85.6592 133.468 85.0259 133.709 84.3865 133.709H84.3926ZM59.0479 105.874C58.7825 106.139 58.6378 106.489 58.6378 106.857C58.6378 107.225 58.7825 107.58 59.0479 107.84L83.4094 132.201C83.9523 132.744 84.8389 132.744 85.3818 132.201L109.743 107.84C110.009 107.574 110.153 107.225 110.153 106.857C110.153 106.489 110.009 106.133 109.743 105.874L85.3757 81.5181C84.8329 80.9753 83.9462 80.9753 83.4034 81.5181L59.0479 105.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2869 108.473C90.8405 108.473 90.5088 108.581 90.1771 108.581L86.9562 105.361L89.6222 102.695L93.0662 101.47L95.6236 97.3626C95.7321 97.1395 95.7321 96.8077 95.6236 96.6931L94.2906 95.3602C94.0674 95.137 93.7357 95.137 93.5125 95.2516L89.2904 97.6944L87.9574 101.247L85.2915 103.913L82.2938 100.692C82.2938 100.36 82.4024 100.023 82.4024 99.5823C82.4024 96.6931 79.6279 94.5821 76.8473 95.2516L78.512 96.9163C79.3987 97.803 79.3987 99.1359 78.512 100.029C77.6254 100.921 76.2924 100.915 75.3997 100.029L73.6204 98.4725C72.7338 101.693 75.7315 104.806 79.0669 103.804L82.2878 107.025L80.9548 108.358C80.1767 108.135 79.3987 108.358 78.8437 108.913L74.2899 113.467C73.4033 114.354 73.2887 115.687 74.0667 116.579C74.9534 117.58 76.401 117.58 77.2876 116.688L81.956 112.019C82.5109 111.464 82.7341 110.578 82.5109 109.908L83.8439 108.575L87.0648 111.796C86.9562 112.128 86.9562 112.574 86.9562 112.906C86.9562 115.795 89.7307 117.906 92.5113 117.237L90.8466 115.572C89.9599 114.685 89.9599 113.352 90.8466 112.46C91.7332 111.567 93.0662 111.573 93.9589 112.46L95.6236 114.124C96.4016 111.235 94.182 108.461 91.2929 108.461L91.2869 108.473Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3125 105.493L83.3484 76.4572C83.6983 76.1074 84.1567 75.9265 84.6211 75.9023V137.822C84.1567 137.798 83.7043 137.617 83.3484 137.267L54.3064 108.226C53.5525 107.472 53.5525 106.247 54.3064 105.493H54.3125Z",
    fill: "url(#paint5_linear_32346_435055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6045 107.037C60.6045 106.506 61.0327 106.078 61.5635 106.078C62.0943 106.078 62.5225 106.506 62.5225 107.037C62.5225 107.568 62.0943 107.996 61.5635 107.996C61.0327 107.996 60.6045 107.568 60.6045 107.037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.123 107.037C105.123 106.506 105.551 106.078 106.082 106.078C106.613 106.078 107.041 106.506 107.041 107.037C107.041 107.568 106.613 107.996 106.082 107.996C105.551 107.996 105.123 107.568 105.123 107.037Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8721 80.0098C51.3369 81.0751 51.8705 81.7566 52.6221 83.2598",
    stroke: "#D0D6D5",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.54 137.951C175.601 135.531 178.04 136.421 178.04 133.951",
    stroke: "#D0D6D5",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.856 91.4512C171.387 92.0703 170.851 92.4387 171.106 93.2012",
    stroke: "#D0D6D5",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5293 62.9727C95.0368 62.2748 95.5293 61.8086 95.5293 60.9727C95.5293 60.5301 95.3769 59.9239 95.7793 59.7227",
    stroke: "#D0D6D5",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.041 143.201C54.8713 142.505 54.6937 141.778 54.041 141.451",
    stroke: "#D0D6D5",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32346_435055",
    x: 51.5234,
    y: 45.1426,
    width: 129.277,
    height: 140.525,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32346_435055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32346_435055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_32346_435055",
    x: 63.8799,
    y: 45.1426,
    width: 104.54,
    height: 131.43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0784314 0 0 0 0 0.109804 0 0 0 0 0.101961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32346_435055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32346_435055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_32346_435055",
    x: 51.5234,
    y: 159.461,
    width: 129.277,
    height: 24.207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0784314 0 0 0 0 0.109804 0 0 0 0 0.101961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32346_435055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32346_435055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_32346_435055",
    x: 49.4219,
    y: 75.8867,
    width: 69.9414,
    height: 71.9414,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32346_435055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32346_435055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32346_435055",
    x1: 79.674,
    y1: 122.365,
    x2: 224.284,
    y2: 134.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF002C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32346_435055",
    x1: 79.674,
    y1: 122.365,
    x2: 224.284,
    y2: 134.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF002C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32346_435055",
    x1: 227.164,
    y1: 128.341,
    x2: 98.7537,
    y2: 117.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32346_435055",
    x1: 124.139,
    y1: 175.668,
    x2: 124.139,
    y2: 163.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF002C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_32346_435055",
    x1: 69.7234,
    y1: 131.901,
    x2: 127.417,
    y2: 90.5897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD37E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_32346_435055",
    x1: 24.4791,
    y1: 117.263,
    x2: 84.4312,
    y2: 112.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintaince);
export default __webpack_public_path__ + "static/media/maintaince.235a2013151958ccf4c5ceed5fd3026d.svg";
export { ForwardRef as ReactComponent };